import {createRouter, createWebHashHistory} from 'vue-router';

/*
 * Define router to each view
 */

const routes = [
  {
    path: '/',
    name: 'Home',
    component:  () => import('../views/Main.vue')
  },
  {
    path: '/store/:supplierRefId',
    name: 'Store',
    component:  () => import('../views/Store.vue')
  },
  {
    path: '/product-details/:supplierRefId/:productRefId',
    name: 'Product Details',
    component: () => import('../views/ProductInfo.vue')
  },
  {
    path: '/inquiry',
    name: 'Inquiry',    
    component: () => import('../views/Inquiry.vue')
  },
  {
    path: '/cart',
    name: 'Cart Info',    
    component: () => import('../views/Cart.vue')
  },
  {
    path: '/order-init',
    name: 'Order Init',
    component: () => import('../views/OrderInit.vue')
  },
  {
    path: '/order',
    name: 'Order',    
    component: () => import('../views/Order.vue')
  },
  {
    path: '/checkout/:supplierRefId/:orderId',
    name: 'Checkout',    
    component: () => import('../views/Checkout.vue')
  },
  {
    path: '/terms',
    name: 'Terms',    
    component: () => import('../views/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',    
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/contact/:supplierRefId',
    name: 'StoreContact',    
    component: () => import('../views/StoreContact.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
	scrollBehavior () {
        return { left: 0, top: 0 };
    }
})

export default router
